import React from "react";
import PropTypes from "prop-types";

import { useIntl } from "react-intl";

import "./style.scss";

/**
 * PlainText:
 *  - Component renders any passed HTML String to DOM
 */
export function PlainText(props) {
  const styleClasses = {
    h2: "tag heading",
    h3: "tag heading",
    h5: "tag heading",
    p: "tag content_component",
    b: "tag highlight",
    i: "tag",
    sup: "tag hyperlink",
    em: "tag",
    rfp: "tag",
  };
  const directionalTag = ["p", "h3", "h2", "h5"];
  const intl = useIntl();

  const renderElement = (element) => {
    const { tag, attributes, value, placeholders } = element;

    if (directionalTag.includes(tag) && !attributes.dir){
      attributes.dir = intl.locale == 'ar' ? 'rtl' : 'ltr';
    }

    let content = intl.formatMessage({ id: value, defaultMessage: value });

    if (placeholders) {
      Object.entries(placeholders).forEach(([placeholder, childElement]) => {
        content = content.replace(placeholder, `__${placeholder}__`);
      });
    }

    const Tag = tag;

    return (
      <Tag
        className={styleClasses[tag]}
        {...attributes}
      >
        {content.split(/__|__/).map((part, index) => {
          if (placeholders && placeholders[`__${part}__`]) {
            return renderElement(placeholders[`__${part}__`]);
          }
          return part;
        })}
      </Tag>
    );
  };
  if (!props.text && !props.tag) {
    return <></>;
  }

  if (props.tag) {
    return renderElement(props);
  }
  return intl.formatMessage(
    {
      id: props.text,
      defaultMessage: props.text,
    },
    {
      p: (chunks) => (
        <p
          className="tag content_component"
          dir={intl.locale == "ar" ? "rtl" : "ltr"}
        >
          {chunks}
        </p>
      ),
      h3: (chunks) => (
        <h3 className="tag heading" dir={intl.locale == "ar" ? "rtl" : "ltr"}>
          {chunks}
        </h3>
      ),
      h2: (chunks) => (
        <h2 className="tag heading" dir={intl.locale == "ar" ? "rtl" : "ltr"}>
          {chunks}
        </h2>
      ),
      b: (chunks) => (
        <b className="tag highlight" dir={intl.locale == "ar" ? "rtl" : "ltr"}>
          {chunks}
        </b>
      ),
      sup: (chunks) => (
        <sup
          className="tag hyperlink"
          dir={intl.locale == "ar" ? "rtl" : "ltr"}
        >
          {chunks}
        </sup>
      ),
      em: (chunks) => (
        <em dir={intl.locale == "ar" ? "rtl" : "ltr"}>{chunks}</em>
      ),
      i: (chunks) => <i>{chunks}</i>,
      rfp: (chunks) => (
        <rfp dir={intl.locale == "ar" ? "rtl" : "ltr"}>{chunks}</rfp>
      ),
      h5: (chunks) => (
        <h5 className="tag heading" dir={intl.locale == "ar" ? "rtl" : "ltr"}>
          {chunks}
        </h5>
      ),
    }
  );
}

PlainText.propTypes = {
  /**
   * HTML content to be rendered to DOM passed in as string
   */
  text: PropTypes.string.isRequired,
  /**
   * ClassName to se on HTML Tag
   */
  className: PropTypes.string,
  /**
   * Callback to invoke for when Highlighted tag is clicked
   */
  onClickHighlight: PropTypes.func,
};

PlainText.defaultProps = {
  text: "",
  className: "",
};
